import { useDebounce } from "./useDebounce";

export function useDebouncedSearchText(
  value: string | undefined,
  delay = 500
): string {
  const normalized = value ?? "";
  const debounced = useDebounce(normalized, delay);
  return normalized === "" ? "" : debounced;
}
